import { Menu } from 'antd'
import styled, { css } from 'styled-components'

const StyledSubMenu = styled(Menu.SubMenu)`
  .ant-menu-submenu-title {
    padding: 0;
    margin: 0;
  }

  ${props =>
    props.imitateDisabled &&
    css`
      .ant-menu-submenu-title {
        color: rgba(0, 0, 0, 0.25) !important;
        cursor: not-allowed !important;
      }
      .ant-menu-submenu-title .ant-menu-submenu-arrow {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    `}
`

export default StyledSubMenu
